import { findArray } from 'helpers/utils';
import MirsTable from 'components/general/table/Table.js';
import { NocMemo as Noc } from 'components/presentation/Noc';
import Competitor from 'components/presentation/Competitor';
import Label from "components/general/Label";
import { useMemo } from 'react';
import { useViewport } from 'components/general/useViewPort';
import SportCode from "components/common/SportCode"
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


const TeamStatistics = ({ data, stats, period }) => {
  const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()
  const tableColumns = useMemo(() =>
    [

      {
        id: 'Statistics',
        Header: <Label data={'HeaderStatistics'} />,
        accessor: 'code',
        className: 'text-start w-40',
        Cell: (props) => {
          let row = props.cell.row.original
          let label = row.header ? row.header : props.value
          return (
            <Label data={label} sport={mirs_discipline} />
          )
        }
      },
      {
        id: 'TeamHome',
        Header:
          <div className='d-flex align-items-center justify-content-center'>
            <div className='d-none d-md-block me-1'>
              <Noc className='d-none d-sm-flex me-1' {...findArray(data.items, { startSortOrder: [1] })?.participant?.organisation} />
            </div>
            <strong>
              <Competitor hidePicture={true} {...findArray(data.items, { startSortOrder: [1] })?.participant} />
            </strong>
          </div>,
        headerClassName: "text-center",
        accessor: 'code',
        className: 'text-center w-30',
        Cell: (props) => {
          let team = findArray(data.items, { startSortOrder: [1] })
          let teamValue = team.statsItems?.find(filter => (filter.pos === undefined || filter.pos === period) && filter.code === props.value);
          let component = props.cell.row.original.component !== undefined ? props.cell.row.original.component : '-';
          let paint = props.cell.row.original.paint !== undefined ? props.cell.row.original.paint : '-';
          let code = props.cell.row.original.code !== undefined ? props.cell.row.original.code : '';

          switch (component) {
            case "type2":
              return (<TeamStatsType2 value={teamValue?.value} attempt={teamValue?.attempt} percent={teamValue?.percent} />)
            case "type3":
              return (<TeamStatsType3 value={teamValue?.value} paint={findArray(teamValue?.extendedStatsItems, { code: [paint] }).value} />)
            default:
              return (<TeamStatsType1 value={teamValue?.value} />)
          }
        },
      },
      {
        id: 'TeamAway',
        Header:
          <div className='d-flex align-items-center justify-content-center'>
            <div className='d-none d-md-block me-1'>
              <Noc className='d-none d-sm-flex me-1'  {...findArray(data.items, { startSortOrder: [2] })?.participant?.organisation} />
            </div>
            <strong>
              <Competitor hidePicture={true} {...findArray(data.items, { startSortOrder: [2] })?.participant} />
            </strong>
          </div>,
        headerClassName: "text-center",
        accessor: 'code',
        className: 'text-center w-30',
        Cell: (props) => {
          let team = findArray(data.items, { startSortOrder: [2] })
          let teamValue = team.statsItems?.find(filter => (filter?.pos === undefined || filter?.pos === period) && filter?.code === props?.value);
          let component = props.cell.row.original.component !== undefined ? props.cell.row.original.component : '-';
          let paint = props.cell.row.original.paint !== undefined ? props.cell.row.original.paint : '-';
          let code = props.cell.row.original.code !== undefined ? props.cell.row.original.code : '';

          switch (component) {
            case "type2":
              return (<TeamStatsType2 value={teamValue?.value} attempt={teamValue?.attempt} percent={teamValue?.percent} />)
            case "type3":
              return (<TeamStatsType3 value={teamValue?.value} paint={findArray(teamValue?.extendedStatsItems, { code: [paint] }).value} />)
            default:
              return (<TeamStatsType1 value={teamValue?.value} />)
          }
        },
      },
    ], [data]
  )
  return (
    <MirsTable
      id={`mirs-table-team-statistics-${mirs_rsc}`}
      data={stats}
      columns={tableColumns}
      showLoading={false}
    />
  )
}

// SE MUESTRA SOLO UN VALOR '25'
function TeamStatsType1({ value }) {
  return (
    <>
      {value !== undefined ? value : ''}
    </>
  )
}
// SE MUESTRAN TRES VALORES '2/4 50%'
function TeamStatsType2({ value, attempt, percent }) {
  return (
    <>
      {value !== undefined ? value + '/' + attempt + ' ' + percent + '%' : ''}
    </>
  )
}
// SE MUESTRAN UN SUB-VALOR '25'
function TeamStatsType3({ value, paint }) {
  return (
    <>
      {value !== undefined ? paint : ''}
    </>
  )
}

const ResponsiveHeaders = ({ mirs_discipline, entity, code }) => {
  const { breakPoint } = useViewport()
  if (breakPoint === "sm" || breakPoint === "xs") {
    return (
      <>{code}</>

    )
  }
  else {
    return (
      <>
        <SportCode discipline={mirs_discipline} entity={entity} code={code} />
      </>
    )
  }

}

export default TeamStatistics;